import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export type FollowingFeedNode = {
	content?: {
		contentProperties?: {
			latest?: {
				generatedBy?: string | null;
			} | null;
		} | null;
	} | null;
};

export type PopularFeedNode = {
	content?: {
		labels?: {
			nodes?: ReadonlyArray<{ name?: string | null } | null> | null;
		} | null;
		contentProperties?: {
			latest?: {
				generatedBy?: string | null;
			} | null;
		} | null;
	} | null;
};

/**
 * A following-feed node is hidden only when it was generated by onboarding AND the
 * `cc-activation-use-generated-by-exp-gate` experiment is in the `test` cohort. Shared between
 * `Feed` (deciding whether the feed has any visible content) and `ActivityFeedCards` (filtering
 * the rendered list and pagination) so the predicate stays in one place.
 */
export const isVisibleFollowingFeedNode = (item?: FollowingFeedNode | null): boolean =>
	item?.content?.contentProperties?.latest?.generatedBy !== 'ONBOARDING' ||
	!expValEquals('cc-activation-use-generated-by-exp-gate', 'cohort', 'test');

/**
 * Shared between `PopularFeedCards` (filtering the rendered list + pagination)
 * and `Feed` (deciding whether the Popular feed has any visible content)
 */
export const isVisiblePopularFeedNode = (item?: PopularFeedNode | null): boolean => {
	if (
		item?.content?.labels?.nodes?.some(
			(value) => value?.name === 'farewell-blog' || value?.name === 'welcome-blog',
		) &&
		StatsigConfigurations.getBoolean('confluence-welcome-farewell-feed-internal', false)
	) {
		return false;
	}

	if (
		item?.content?.contentProperties?.latest?.generatedBy === 'ONBOARDING' &&
		expValEquals('cc-activation-use-generated-by-exp-gate', 'cohort', 'test')
	) {
		return false;
	}

	return true;
};
